"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Clock = function Clock(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.875 2.564C5.775 2.564 2.44 5.9 2.44 10s3.336 7.436 7.436 7.436S17.311 14.1 17.311 10s-3.335-7.436-7.436-7.436zm0 13.72c-3.464 0-6.28-2.82-6.28-6.284s2.82-6.28 6.28-6.28a6.29 6.29 0 016.28 6.28c0 3.46-2.816 6.284-6.28 6.284z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.74 10.228H9.828V7.696a.576.576 0 00-1.152 0v3.108c0 .32.26.576.576.576.008 0 .012-.004.02-.004s.012.004.02.004h3.448a.576.576 0 000-1.152z",
    fill: color
  }));
};
var _default = exports["default"] = Clock;